import React from 'react'
import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'

const GameNav = () => {

    const currentLocation = useLocation();
    const [gameNav, setGameNav] = useState(false);

    const toggleGameNav = () => {
        setGameNav(!gameNav);
    }

    return (

        <div className='game-nav-parent'>
            <div className='game-nav'>

                <Link to='/' style={{ textDecoration: 'none' }}>
                    <img src={process.env.PUBLIC_URL + '/images/home-icon-red.png'} width="30px" />
                </Link>


                <div onClick={toggleGameNav} id='hamburger-game-menu'>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>

            </div>

            {gameNav ? (

                <nav className='game-nav-open'>

                    <div onClick={toggleGameNav} className='exit-game-nav'>
                        <svg className='cxo-game' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 105.55 105.56">
                            <path className='cxg' d="M250.1,360.72a9.14,9.14,0,0,1,0,12.93l-5.45,5.45a9.14,9.14,0,0,1-12.93,0L200,347.38,168.28,379.1a9.14,9.14,0,0,1-12.93,0l-5.45-5.45a9.14,9.14,0,0,1,0-12.93L181.62,329,149.9,297.28a9.14,9.14,0,0,1,0-12.93l5.45-5.45a9.14,9.14,0,0,1,12.93,0L200,310.62l31.72-31.72a9.14,9.14,0,0,1,12.93,0l5.45,5.45a9.14,9.14,0,0,1,0,12.93L218.38,329Z" transform="translate(-147.22 -276.22)" />
                        </svg>
                    </div>



                    <div className='game-links'>


                        <Link style={{ textDecoration: 'none' }} to='/' className='link-mobile'>
                            <div className='game-link'>
                                <img className="tab-icon" src={process.env.PUBLIC_URL + '/images/home-icon-red.png'} ></img>
                                <p>Home</p>
                            </div>
                        </Link>

                        <Link style={{ textDecoration: 'none' }} to='/about' className='link-mobile'>
                            <div className='game-link'>
                                <img className="tab-icon" src={process.env.PUBLIC_URL + '/images/about-icon-red.png'} ></img>
                                <p>About</p>
                            </div>
                        </Link>

                        <Link style={{ textDecoration: 'none' }} to='/articlespage' className='link-mobile'>
                            <div className='game-link'>
                                <img className="tab-icon" src={process.env.PUBLIC_URL + '/images/article-icon-red.png'} ></img>
                                <p>Articles</p>
                            </div>
                        </Link>

                        <Link style={{ textDecoration: 'none' }} to='/games' className='link-mobile'>
                            <div className='game-link'>
                                <img className="tab-icon" src={process.env.PUBLIC_URL + '/images/controller-yellow.png'} ></img>
                                <p>Games</p>
                            </div>
                        </Link>

                        <Link style={{ textDecoration: 'none' }} to='/activitiespage' className='link-mobile'>
                            <div className='game-link'>
                                <img className="tab-icon" src={process.env.PUBLIC_URL + '/images/activities-icon-red.png'} ></img>
                                <p>Activities</p>
                            </div>
                        </Link>


                    </div>
                </nav>
            ) : (
                <></>
            )}

        </div>
    )
}

export default GameNav